<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import store from "@/store";
import router from "@/router";

@Component
export default class ActivityTrackerMixin extends Vue {
    private inactivityTimeout: number | null = null;
    private readonly logoutAfter = 15 * 60 * 1000; // 15 minutes

    mounted() {
        // Initialize activity tracking
        this.resetInactivityTimer();
        this.addActivityListeners();
    }

    beforeDestroy() {
        // Cleanup listeners and timers
        this.removeActivityListeners();
        this.clearInactivityTimer();
    }

    private addActivityListeners() {
        const events = ['mousemove', 'click', 'keypress', 'scroll'];
        events.forEach(event => window.addEventListener(event, this.resetInactivityTimer));
    }

    private removeActivityListeners() {
        const events = ['mousemove', 'click', 'keypress', 'scroll'];
        events.forEach(event => window.removeEventListener(event, this.resetInactivityTimer));
    }

    private resetInactivityTimer = () => {
        this.clearInactivityTimer();
        this.inactivityTimeout = window.setTimeout(async () => {
            await this.handleLogout();
        }, this.logoutAfter);
    };

    private clearInactivityTimer() {
        if (this.inactivityTimeout) {
            clearTimeout(this.inactivityTimeout);
            this.inactivityTimeout = null;
        }
    }

    private async handleLogout() {
        if (router.currentRoute.name !== 'AccountLogin') {
            await store.dispatch('clear');
            await router.push({ name: 'AccountLogin' });
        }
    }
}
</script>
